import type { ConversationMessage } from '../types';

type ComposerMessageRef = Pick<ConversationMessage, 'id' | 'created_at'>;

type BuildCreateMessageRequestInput = {
  content: string;
  holdQueuedMessages: boolean;
  modelId?: string | null;
  parentMessageId?: string | null;
  attachmentIds?: string[];
};

function compareMessages(left: ComposerMessageRef, right: ComposerMessageRef) {
  const createdAtDiff =
    new Date(left.created_at).getTime() - new Date(right.created_at).getTime();
  if (createdAtDiff !== 0) {
    return createdAtDiff;
  }
  return left.id.localeCompare(right.id);
}

export function resolveComposerParentMessageId(
  messages: readonly ComposerMessageRef[],
  queuedMessageOrder: readonly string[] = []
): string | null {
  if (queuedMessageOrder.length > 0) {
    return queuedMessageOrder.at(-1) ?? null;
  }
  if (messages.length === 0) {
    return null;
  }
  return [...messages].sort(compareMessages).at(-1)?.id ?? null;
}

export function buildCreateMessageRequest(input: BuildCreateMessageRequestInput) {
  return {
    content: input.content,
    auto_process: !input.holdQueuedMessages,
    model_id: input.modelId ?? undefined,
    parent_message_id: input.parentMessageId ?? undefined,
    attachment_ids: input.attachmentIds && input.attachmentIds.length > 0 ? input.attachmentIds : undefined
  };
}
